import React, { useState } from "react";
import { Col, Row, Tooltip } from "reactstrap";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core";
import { useKeycloak } from "@react-keycloak/web";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  MULTITENANT_CONSTANTS,
  TENANT,
  TENANT_PETISGO,
} from "../../../../../app/src/Resources/Multitenant/tenantConstants";
import { logoutFromKeycloak } from "../../../../../app/src/Utils/keycloak";
import { userLoginActionCreator, saveUserDataActionCreator } from "../../../../../app/src/actions/commonActions";
import { URL_HOME, URL_LOGIN } from "../../../../../app/src/Components/Routes/Location";
import { removeTokenFromCookie } from "../../../../../app/src/Utils/utils";
import { isCordovaAvailable } from "../../../../../app/src/Utils/secureStorageUtil";
import "./DesactivateUserModalComponent";

const useStyles = makeStyles(() => ({
  iconContainer: {
    zIndex: 0,
  },
}));

const UserButtonOptionsComponent = ({
  handlePasswordModal,
  handleDisplayOnBoarding,
  handleTermsModal,
  handleDeactivateUserModal,
  checkoutURL,
  terms,
  tutorialUrl,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { keycloak } = useKeycloak();
  const dispatch = useDispatch();
  const history = useHistory();

  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleRedirectToTutorial = () => {
    window.location.href = tutorialUrl;
  };

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const logout = async () => {
    if (isCordovaAvailable()) {
      dispatch(userLoginActionCreator(null));
      dispatch(saveUserDataActionCreator({username: null, role: null}));
      logoutFromKeycloak();
      await removeTokenFromCookie();
      history.push(URL_LOGIN);
    } else {
      window.TiiviiPlayer?.destroyAll();
      await removeTokenFromCookie();
      await keycloak?.logout({ redirectUri: window.location.origin + URL_HOME });
    }
  };

  return (
    <Col md={12}>
      <Row className={"OptionsContainer"}>
        <h2 className={"Title-bold"}>{t("perfil.otras.opciones")}</h2>
      </Row>
      <Row className={"OptionButtonsRow"}>
        {(!!tutorialUrl || !!MULTITENANT_CONSTANTS[TENANT].showOnBoarding) && (
          <div
            className={"ProfileOptionButton"}
            onClick={() =>
              !!tutorialUrl
                ? handleRedirectToTutorial()
                : handleDisplayOnBoarding(false)
            }
          >
            <div className={classes.iconContainer}>
              <ion-icon name="eye" aria-label={t("perfil.watch.tutorial")} />
            </div>
            <span>{t("perfil.watch.tutorial")}</span>
          </div>
        )}
        {!!terms && (
          <div
            className={"ProfileOptionButton"}
            onClick={() => handleTermsModal(true)}
          >
            <div className={classes.iconContainer}>
              <ion-icon name="reader" aria-label={t("perfil.read.terms")} />
            </div>
            <span>{t("perfil.read.terms")}</span>
          </div>
        )}
        {MULTITENANT_CONSTANTS[TENANT].showSubscriptions && (
          <div
            className={"ProfileOptionButton"}
            onClick={() => window.open(checkoutURL)}
          >
            <div className={classes.iconContainer}>
              <ion-icon name="cart" aria-label={t("perfil.watch.subscriptions")} />
            </div>
            <span>{t("perfil.watch.subscriptions")}</span>
          </div>
        )}
        <div
          className={"ProfileOptionButton"}
          onClick={() => handlePasswordModal(true)}
        >
          <div className={classes.iconContainer}>
            <ion-icon name="lock-closed" aria-label={t("perfil.update.password")} />
          </div>
          <span>{t("perfil.update.password")}</span>
        </div>
        <div
          className={"ProfileOptionButton"}
          onClick={logout}
        >
          <div className={classes.iconContainer}>
            <ion-icon name="exit-sharp" aria-label={t("user.logout")} />
          </div>
          <span>{t("user.logout")}</span>
        </div>
      </Row>
      <Row className={"OptionButtonsRow"}>
  {!!handleDeactivateUserModal && <div
    className={"ProfileOptionButton ProfileOptionButton--danger"}
    onClick={() => handleDeactivateUserModal(true)} 
  >
    <div className={classes.iconContainer}>
      <ion-icon name="warning" aria-label={t("perfil.deactivate.account")} />
    </div>
    <span>{t("perfil.deactivate.account")}</span>
  </div>}
</Row>
    </Col>
  );
};

export default UserButtonOptionsComponent;
